import { Slider } from "components/common/Slider/Slider";
import { Translate } from "components/common/Translate/Translate";
import { useOpacity } from "components/modules/Editors/MemeGenerator/ControlBar/TextSettings/MoreOptions/MoreOptionsContent/Opacity/useOpacity";
import { TextBox } from "store/features/memeGenerator/types";

interface OpacityProps {
    textBox: TextBox;
}

export const Opacity = ({ textBox }: OpacityProps) => {
    const { handleOpacityChange } = useOpacity(textBox);
    return (
        <div className="flex flex-col gap-2">
            <label className="capitalize">
                <Translate keyName="opacity" />
            </label>
            <div className="flex items-center justify-between border border-irGray-200 dark:border-darkSurface-400 dark:bg-darkSurface-200 p-4 rounded-[10px] gap-4">
                <div className="w-full">
                    <Slider
                        defaultValue={0}
                        value={textBox.opacity}
                        handleChange={handleOpacityChange}
                        max={100}
                        min={0}
                    />
                </div>
                <div className="translate-y-0.5">{textBox.opacity}%</div>
            </div>
        </div>
    );
};
